module.exports = __webpack_public_path__ + "svg_80x80/bootstrap.8ce739.svg";